import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Ambassador from '../views/Ambassador.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  }, {
    path: '/ambassador',
    name: 'Ambassador',
    component: Ambassador
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
